import React from "react";
import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

type TitleProps = {
  label: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      margin: theme.spacing(5, 0),
    },
  })
);

export default function Title({ label }: TitleProps) {
  const classes = useStyles();

  return (
    <Typography variant="h4" color="secondary" className={classes.title}>
      {label}
    </Typography>
  );
}
